import loading from "../assets/loading.svg";
import { cn } from "@/lib/utils.ts";
import { PageCenter } from "@/components/PageCenter.tsx";

interface Props {
  message: string;
  className?: string;
}

export function Loader({ message, className }: Props) {
  return (
    <PageCenter>
      <div className={cn("flex flex-col py-12 px-28 items-center justify-center gap-8", className)}>
        <img className={"animate-spin w-6"} src={loading} alt="Loading icon" />
        <p className={"text-center text-muted-foreground"}>{message}</p>
      </div>
    </PageCenter>
  );
}
